module.exports = __webpack_public_path__ + "static/sport/euro.ffb4d2b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/euro.gif
// module id = 1cCA
// module chunks = 0